import {ServiceAnswer, ServiceAnswerAny} from '../../shared/service-answer';
import { MessageService } from '../../shared/message.service';

export class ServiceTools {

  /**
   * Returns a list of entities from the given context. Takes entities from the first context if the
   * given context contains multiple subcontexts.
   * @param serviceAnswer The serviceAnswer from which the entities are taken.
   * @param messageService The messageService used for error message.
   * @param entityNamePlural The entity name in plural form. Used in error messages.
   */
  public static getEntitiesFromFirstContext(
    serviceAnswer: ServiceAnswerAny,
    messageService: MessageService,
    entityNamePlural?: string): any[] {
    try {
      if (serviceAnswer.isOk) {
        if (!serviceAnswer.isDataEqual) {
          console.log('Data equal');
          messageService.addDanger('Entities fetched from different servers are not equal.');
        }
        return serviceAnswer.serviceAnswer ? serviceAnswer.serviceAnswer[0].data : serviceAnswer.data;
      } else {
        const errorMessage = ServiceTools.getErrorMessage(
          serviceAnswer,
          `Fetching ${entityNamePlural ? entityNamePlural : 'entities'} failed.`);
        console.error(errorMessage);
        messageService.addDanger(errorMessage);
      }
    } catch (error) {
      const message = `Unexpected error when fetching ${entityNamePlural ? entityNamePlural : 'entities'}: ${JSON.stringify(error)}`;
      console.error(message);
      messageService.addDanger(message);
    }
  }

  /**
   * Returns an entity from the given context. Takes the entity from the first context if the
   * given context contains multiple subcontexts.
   * @param serviceAnswer The serviceAnswer from which the entity is taken.
   * @param messageService The messageService used for error message.
   * @param entityNamePlural The entity name in singular form. Used in error messages.
   */
  public static getEntityFromFirstContext(serviceAnswer: ServiceAnswerAny, messageService: MessageService, entityNameSingular?: string): any {
    try {
      if (serviceAnswer.isOk) {
        if (!serviceAnswer.isDataEqual) {
          messageService.addDanger('Entity datas fetched from different servers are not equal.');
        }
        return serviceAnswer.serviceAnswer ? serviceAnswer.serviceAnswer[0].data : serviceAnswer.data;
      } else {
        const errorMessage = ServiceTools.getErrorMessage(
          serviceAnswer,
          `Fetching ${entityNameSingular ? entityNameSingular : 'entity'} failed`);
        console.error(errorMessage);
        messageService.addDanger(errorMessage);
      }
    } catch (error) {
      const message = `Unexpected error when fetching ${entityNameSingular ? entityNameSingular : 'entity'}: ${JSON.stringify(error)}`;
      console.error(message);
      messageService.addDanger(message);
    }
  }

  /**
   * Return error message as string.
   * @param serviceAnswer The serviceAswer from which the details are taken.
   */
  static getErrorMessage(serviceAnswer: ServiceAnswerAny, errorMessage?: string, prefix?: string): string {

    if (!prefix) {
      prefix = '';
    }
    console.log(JSON.stringify(serviceAnswer));

    const numberOfAnswers: number = !serviceAnswer.serviceAnswer ? 1 : serviceAnswer.serviceAnswer.length;
    let innerServiceAnswers = '';
    let count = 0;
    if (serviceAnswer.serviceAnswer) {
      serviceAnswer.serviceAnswer.forEach(
        (serviceAnswerInner: ServiceAnswerAny) =>
          innerServiceAnswers += `--
          ${ServiceTools.getErrorMessage(serviceAnswerInner, null, `${++count}`)}`);
    }

    const error =
      `${errorMessage ? `${prefix} ${errorMessage} \n` : ''}`
      + (`${prefix} Is ok: ${serviceAnswer.isOk + (!serviceAnswer.isOk ? '' : ' (no error)')} \n`)
      + (serviceAnswer.errorCode ? `${prefix} Error code: ${serviceAnswer.errorCode}\n` : '')
      + (serviceAnswer.errorMessage ? `${prefix} Error message: ${serviceAnswer.errorMessage}\n` : '')
      + ((numberOfAnswers > 1) ? `${prefix} Number of service answers: ${numberOfAnswers}\n` : '')
      + (`${numberOfAnswers > 1 ? `${prefix} Answers below:\n` : ''}`)
      + (`${serviceAnswer.serviceAnswer ? innerServiceAnswers : ''}`);

    return error;
  }
}
